'use client';

import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { TopBarMenuButton } from '../TopBarMenuButton/TopBarMenuButton';
import {
  type IMenuProps,
  Menu,
} from '../../../../../common/components/Menu/Menu';
import { UserTopBarMenu } from '../UserTopBarMenu/UserTopBarMenu';
import { RegularPersonWithAccountLevel } from '../../../Reusable/RegularPersonWithAccountLevel/RegularPersonWithAccountLevel';
import { IMainNavigationTranslations } from '../../../utils/getMainNavigationTranslations';

const dropdownMenuProps: IMenuProps['dropdownMenuProps'] = {
  style: {
    width: '370px',
    maxWidth: `calc(100vw - 40px)`,
    backgroundColor: 'transparent',
    borderRadius: '12px',
  },
  align: 'end',
  sideOffset: 5,
  sticky: 'always',
  updatePositionStrategy: 'always',
};

export const ProfileDropdownMenu: FC<{
  translatedValues: IMainNavigationTranslations;
}> = ({ translatedValues }) => {
  return (
    <Menu
      components={{
        buttonElement: (
          <TopBarMenuButton
            ariaLabel="open profile settings menu"
            className={css({
              minWidth: '46px',
              width: 'auto',
              flexShrink: 1,
              py: 'small',
            })}
          >
            <RegularPersonWithAccountLevel size={12} />
          </TopBarMenuButton>
        ),
        menuContent: (
          <UserTopBarMenu
            translatedValues={translatedValues}
            isWithinDropdown
          />
        ),
      }}
      dropdownMenuProps={dropdownMenuProps}
    />
  );
};
